var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m109.28 89.187c0 7.6164-6.0146 13.791-13.434 13.791-7.4195 0-13.434-6.1743-13.434-13.791 0-7.6164 6.0146-13.791 13.434-13.791 7.4194 0 13.434 6.1743 13.434 13.791zm-42.636-61.998h11.347v7.3623h-11.347m-1.1979-7.3623h1.1979v12.021h-1.1979zm15.473 26.371c0-7.9255-6.4249-14.35-14.35-14.35-7.9255 0-14.35 6.4249-14.35 14.35m37.864 23.202h-59.352v22.678h10.066v-16.68h5.266v16.68h10.066v-16.68h5.2576v16.68h10.066v-16.68h5.2576v16.68h10.066m-41.47-42.502h42.677v16.372h-42.677zm60.404 42.156v3.7981h-78.132v-3.2968l59.198-0.15564m-56.045-22.678-3.1529 0.017359v-3.4698h78.132v3.3545l-4.3788-0.01736m-58.28-23.161h47.177v3.4524h-47.177z",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 2.3777
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91.759 92.354s-0.06776 2.8848 3.9457 2.8909c3.0685 0.0046 4.0595-1.2288 4.0629-2.8909 0.0071-3.4327-4.0239-3.2035-4.0239-3.2035s-4.031 0.22928-4.0239-3.2035c0.0036-1.6621 0.99438-2.8956 4.0629-2.8909 4.0135 0.0062 3.9457 2.8909 3.9457 2.8909",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.3777
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m95.705 83.017v-3.2816",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.3777
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m95.705 98.253v-3.2816",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.3777
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding);
export default __webpack_public_path__ + "static/media/funding.e3db30cc497f9c861db4bf47b9738003.svg";
export { ForwardRef as ReactComponent };